import React from 'react';
import { Table } from 'antd';
import PnL from '../../../Components/PnL';
import Dot from '../../../Components/Dot';

const PerformanceHistory = ({ data, itemColors }) => {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (_, record)=>(
          <Dot color={itemColors?.[record.symbol]} label={record?.symbol} />
      )
    },
    {
      title: 'YTD',
      dataIndex: 'ytd',
      key: 'ytd',
      // Use renderPnL for formatting YTD
      render: (value) => PnL({value}),
    },
    {
      title: '1 Year % Return',
      dataIndex: 'oneYear',
      key: 'oneYear',
      // Use renderPnL for formatting 1 Year % Return
      render: (value) => PnL({value}),
    },
    {
      title: '3 Year % Return',
      dataIndex: 'threeYear',
      key: 'threeYear',
      // Use renderPnL for formatting 3 Year % Return
      render: (value) => PnL({value}),
    },
    {
      title: '5 Year % Return',
      dataIndex: 'fiveYear',
      key: 'fiveYear',
      // Use renderPnL for formatting 5 Year % Return
      render: (value) => PnL({value}),
    },
  ];

  const dataSource = data.map((row, index) => ({
    key: index,
    symbol: row[0],
    ytd: row[1],
    oneYear: row[2],
    threeYear: row[3],
    fiveYear: row[4],
  }));

  return <Table columns={columns} dataSource={dataSource} pagination={false} style={{maxWidth: '90%', margin: 'auto'}} />
};

export default PerformanceHistory;
